import { makeStyles } from '@mui/styles';

const useAddProcessFormStyles = makeStyles({
	h3: {
		fontSize: 18,
		fontFamily: 'Montserrat',
		fontWeight: '500',
		color: '#003C82',
	},
	textField: {
		'& input': {
			fontFamily: 'Montserrat',
			fontWeight: '500',
			fontSize: 14,
			color: 'rgb(0 0 0 / 64%)',
		},
		'& textarea': {
			fontFamily: 'Montserrat',
			fontWeight: '500',
			fontSize: 14,
			color: 'rgb(0 0 0 / 64%)',
		},
		'& .MuiFormHelperText-root': {
			marginLeft: '0 !important',
		},
	},
	switch: {
		'& span.MuiSwitch-root ': {
			float: 'right',
		},
	},
});

export default useAddProcessFormStyles;
